module.exports = __webpack_public_path__ + "img/logo-light.df5bcf05.svg";